/* SILETH - Free-Piece-Karte im Kollektionsraster (v8).
   Klick oeffnet ein Overlay, das die Mechanik erklaert - kein Seitenwechsel.
   v5: Badge oben links, Pfeil als Tap-Hinweis.
   v6: Infoblock-Hoehe an die Nachbarkachel gekoppelt (Trennlinien auf einer Hoehe).
   v7: Bilder liegen auf einer Spur und lassen sich wischen.
   v8: Die Hoehenmessung laeuft ueber setTimeout statt requestAnimationFrame -
       rAF feuert in versteckten Tabs nicht, dann blieb die Hoehe ungesetzt. */
(function () {
  if (window.__SILETH_PROMO_V2__) return;
  window.__SILETH_PROMO_V2__ = true;

  /* 5.2 (30.08.2026): Die Karte erscheint nur noch auf den hier gelisteten
     Kollektionen. Vorher genuegte "/collections/" im Pfad - dadurch stand sie
     auch auf allen Schmuck-Kollektionen, wo "Gratis zu jeder Uhr" ohne Uhren
     im Raster keinen Sinn ergibt. Weitere Kollektion freischalten = Handle
     hier ergaenzen (z. B. 'watches'). */
  var SHOW_ON = ['varenna', 'watches'];

  var PIECES = [
    { handle: '3mm-cuban-bracelet',        img: 'https://cdn.shopify.com/s/files/1/0766/4848/1107/files/30.png?width=600' },
    { handle: 'original-pendant-necklace', img: 'https://cdn.shopify.com/s/files/1/0766/4848/1107/files/1_32d87501-f674-4eeb-a580-65bf63a02296.png?width=600' },
    { handle: 'compass-necklace',          img: 'https://cdn.shopify.com/s/files/1/0766/4848/1107/files/5_c6a2b591-1fee-4722-8691-87249ff92c85.png?width=600' },
    { handle: '6mm-cuban-bracelet',        img: 'https://cdn.shopify.com/s/files/1/0766/4848/1107/files/7_1413f815-2523-479d-b998-2c2d5aa2217d.png?width=600' }
  ];

  function isDE() {
    return /\/(de|de-de|de-at|de-ch)(\/|$)/i.test(window.location.pathname) ||
           (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;
  }

  function localePrefix() {
    var m = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(?=\/|$)/i);
    return m ? '/' + m[1].toLowerCase() : '';
  }

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(isDE() ? 'de-DE' : 'en-GB', {
        style: 'currency', currency: cur, minimumFractionDigits: 0, maximumFractionDigits: 0
      }).format(cents / 100);
    } catch (e) {
      return Math.round(cents / 100) + ' ' + cur;
    }
  }

  function track() {
    try { if (typeof fbq === 'function') fbq('trackCustom', 'FreePieceInfo'); } catch (e) {}
  }

  var prices = new Array(PIECES.length);
  var pricesLoaded = false;

  function fetchPrices(onEach) {
    if (pricesLoaded) return;
    pricesLoaded = true;
    PIECES.forEach(function (p, k) {
      fetch(localePrefix() + '/products/' + p.handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (d && typeof d.price === 'number') {
            prices[k] = d.price;
            if (onEach) onEach(k, d.price);
            var m = document.querySelector('.spc-modal [data-piece="' + k + '"] .spc-m-was');
            if (m) m.textContent = money(d.price);
          }
        })
        .catch(function () {});
    });
  }

  /* ---------- Infoblock-Hoehe an die Nachbarkachel koppeln ---------- */

  var syncTimer = null;

  function syncInfoHeight() {
    syncTimer = null;
    var card = document.querySelector('.sileth-promo-card');
    if (!card) return;
    var sib = card.previousElementSibling || card.nextElementSibling;
    var info = sib && sib.querySelector('.product-card__info');
    if (!info) return;
    var h = info.getBoundingClientRect().height;
    if (h) card.style.setProperty('--spc-info-h', Math.round(h) + 'px');
  }

  function scheduleSync() {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(syncInfoHeight, 50);
  }

  function watchNeighbour(card) {
    syncInfoHeight();
    scheduleSync();
    var sib = card.previousElementSibling || card.nextElementSibling;
    var info = sib && sib.querySelector('.product-card__info');
    if (info && 'ResizeObserver' in window) new ResizeObserver(scheduleSync).observe(info);
    window.addEventListener('resize', scheduleSync, { passive: true });
    window.addEventListener('load', scheduleSync, { once: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleSync).catch(function () {});
  }

  function build() {
    var cm = window.location.pathname.match(/\/collections\/([^\/?#]+)/i);
    if (!cm || SHOW_ON.indexOf(cm[1].toLowerCase()) === -1) return;
    var list = document.querySelector('.product-list');
    if (!list || list.querySelector('.sileth-promo-card')) return;

    var de = isDE();
    var name  = de ? 'GRATIS SCHMUCKSTÜCK' : 'FREE JEWELRY PIECE';
    var cond  = de ? 'DEINE WAHL, ZU JEDER UHR' : 'YOUR PICK, WITH EVERY WATCH';
    var badge = de ? 'GRATIS' : 'FREE';

    var slides = '', dots = '';
    PIECES.forEach(function (p, k) {
      slides += '<span class="spc-slide"><img src="' + p.img + '" alt="" loading="lazy" draggable="false"></span>';
      dots += '<span class="spc-dot' + (k === 0 ? ' is-on' : '') + '"></span>';
    });

    var card = document.createElement('div');
    card.className = 'sileth-promo-card spc';
    card.innerHTML =
      '<button type="button" class="spc-inner">' +
        '<span class="spc-media">' +
          '<span class="spc-track">' + slides + '</span>' +
          '<span class="spc-badge">' + badge + '</span>' +
          '<span class="spc-dots">' + dots + '</span>' +
        '</span>' +
        '<span class="spc-info">' +
          '<span class="spc-row">' +
            '<span class="spc-name">' + name + '</span>' +
            '<span class="spc-prices"><span class="spc-was" hidden></span> <span class="spc-now">' + money(0) + '</span></span>' +
          '</span>' +
          '<span class="spc-cond"><span class="spc-cond-text">' + cond + '</span><span class="spc-more" aria-hidden="true">&rarr;</span></span>' +
        '</span>' +
      '</button>';
    list.appendChild(card);

    watchNeighbour(card);

    var wasEl = card.querySelector('.spc-was');
    fetchPrices(function (k, price) {
      if (k === 0) { wasEl.textContent = money(price); wasEl.hidden = false; scheduleSync(); }
    });

    var media  = card.querySelector('.spc-media');
    var strip  = card.querySelector('.spc-track');
    var dotEls = card.querySelectorAll('.spc-dot');
    var n = PIECES.length;
    var i = 0;
    var suppressClick = false;
    var timer = null;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function paint() {
      strip.style.transform = 'translate3d(' + (-i * 100) + '%,0,0)';
      dotEls.forEach(function (el, k) { el.classList.toggle('is-on', k === i); });
      if (typeof prices[i] === 'number') { wasEl.textContent = money(prices[i]); wasEl.hidden = false; }
      else { wasEl.hidden = true; }
    }

    function goTo(next) { i = Math.max(0, Math.min(n - 1, next)); paint(); }
    function tick() { i = (i + 1) % n; paint(); }
    function start() { if (!reduce && !timer) timer = setInterval(tick, 2600); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    paint();

    /* Klick oeffnet das Overlay - ein Wisch nicht. */
    card.addEventListener('click', function (e) {
      if (suppressClick) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    card.querySelector('.spc-inner').addEventListener('click', openModal);

    /* ---------- Wischen ---------- */

    var startX = 0, startY = 0, baseX = 0, width = 0;
    var down = false, moved = false;

    media.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      down = true; moved = false;
      startX = e.clientX; startY = e.clientY;
      width = media.getBoundingClientRect().width;
      baseX = -i * width;
      stop();
    });

    media.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;

      if (!moved) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        if (Math.abs(dy) > Math.abs(dx)) { down = false; return; }
        moved = true;
        strip.classList.add('is-dragging');
        if (media.setPointerCapture) { try { media.setPointerCapture(e.pointerId); } catch (err) {} }
      }

      var pull = dx;
      if ((i === 0 && dx > 0) || (i === n - 1 && dx < 0)) pull = dx * 0.35;
      strip.style.transform = 'translate3d(' + (baseX + pull) + 'px,0,0)';
    });

    function release(e) {
      if (!down) return;
      down = false;
      strip.classList.remove('is-dragging');
      if (!moved) { start(); return; }

      var dx = (typeof e.clientX === 'number' ? e.clientX : startX) - startX;
      var threshold = Math.max(30, width * 0.18);

      if (dx <= -threshold) goTo(i + 1);
      else if (dx >= threshold) goTo(i - 1);
      else paint();

      suppressClick = true;
      setTimeout(function () { suppressClick = false; }, 250);
      start();
    }

    media.addEventListener('pointerup', release);
    media.addEventListener('pointercancel', release);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries[0].isIntersecting ? start() : stop();
      }, { threshold: 0.1 }).observe(card);
    } else {
      start();
    }
  }

  function bindHomeTile() {
    var tile = document.querySelector('.sileth-promo-tile');
    if (!tile || tile.dataset.spcBound) return;
    tile.dataset.spcBound = '1';
    fetchPrices(null);
    tile.addEventListener('click', function (e) { e.preventDefault(); openModal(); });
  }

  function openModal() {
    track();

    var existing = document.querySelector('.spc-modal');
    if (existing) { existing.classList.add('is-open'); document.body.classList.add('spc-modal-open'); return; }

    var de = isDE();
    var t = de ? {
      title: 'Gratis Schmuckstück',
      s1: 'Uhr aussuchen und in den Warenkorb legen',
      s2: 'Im Warenkorb erscheint die Auswahl – ein Stück aussuchen',
      s3: 'Der Preis des Schmuckstücks fällt auf ' + money(0),
      note: 'Gilt für jede Uhr, ohne Code.',
      cta: 'Uhr aussuchen'
    } : {
      title: 'Free jewelry piece',
      s1: 'Pick a watch and add it to your cart',
      s2: 'The selection appears in your cart – choose one piece',
      s3: 'Its price drops to ' + money(0),
      note: 'Applies to every watch, no code needed.',
      cta: 'Pick your watch'
    };

    var grid = '';
    PIECES.forEach(function (p, k) {
      grid += '<span class="spc-m-piece" data-piece="' + k + '">' +
        '<img src="' + p.img + '" alt="" loading="lazy">' +
        '<span class="spc-m-priceline"><span class="spc-m-was">' + (typeof prices[k] === 'number' ? money(prices[k]) : '') + '</span> <span class="spc-m-now">' + money(0) + '</span></span>' +
      '</span>';
    });

    var modal = document.createElement('div');
    modal.className = 'spc-modal is-open';
    modal.innerHTML =
      '<div class="spc-m-backdrop" data-close></div>' +
      '<div class="spc-m-panel" role="dialog" aria-modal="true" aria-label="' + t.title + '">' +
        '<button type="button" class="spc-m-x" data-close aria-label="Close">×</button>' +
        '<span class="spc-m-title">' + t.title + '</span>' +
        '<span class="spc-m-grid">' + grid + '</span>' +
        '<ol class="spc-m-steps">' +
          '<li>' + t.s1 + '</li><li>' + t.s2 + '</li><li>' + t.s3 + '</li>' +
        '</ol>' +
        '<span class="spc-m-note">' + t.note + '</span>' +
        '<button type="button" class="spc-m-cta" data-close>' + t.cta + '</button>' +
      '</div>';
    document.body.appendChild(modal);
    document.body.classList.add('spc-modal-open');

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) {
        modal.classList.remove('is-open');
        document.body.classList.remove('spc-modal-open');
      }
    });
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') {
        modal.classList.remove('is-open');
        document.body.classList.remove('spc-modal-open');
      }
    });
  }

  function init() { build(); bindHomeTile(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
